import '../../global'
import Formatter from '../../helpers/Formatter'
import { checkSnooze } from '../../helpers/checkSnooze'
import { convertHours } from '../../helpers/prepTimeFunctions'
import _ from 'lodash'

export function formatMenuItems(data: any, restaurantId: string) {
	let hoursReturn = null
	if (data.hours && Object.keys(data.hours).length !== 0) {
		hoursReturn = convertHours(data.hours, 0)
	}
	return {
		id: data.id,
		posId: data.posId,
		name: data.name,
		description: data.description,
		restaurantId: restaurantId,
		price: data.retailPriceMoney ? data.retailPriceMoney.amount : -1,
		promo: data.promoPrice ? data.promoPrice.amount : -1,
		imageUri: data.itemImage && data.itemImage.url ? data.itemImage.url : '',
		thumbnailUri: data.itemImage && data.itemImage.thumbnailUrl ? data.itemImage.thumbnailUrl : '',
		taxIds: data.taxIds,
		modifierLists: data.modifierLists,
		isSnoozed: data.isSnoozed,
		snoozeUntil: data.snoozeUntil,
		ordinal: data.ordinal || Number.MAX_SAFE_INTEGER,
		hours: hoursReturn,
		variationIds: data.variationIds || [],
		variationMinPrice: data.variationMinPrice || -1,
		variationMaxPrice: data.variationMaxPrice || -1,
		slug: data?.slug ?? '',
		plu: data?.channelData?.plu ?? '',
		ageVerificationRequired: data?.ageVerificationRequired || false,
		posCategory: data?.posCategory,
		seo: data?.seo ?? {},
	}
}

export const getMenuItemData = (menuItemCategories: any, restaurantId, snapshot) => {
	const updatedMenuItemCategories = _.cloneDeep(menuItemCategories)

	return new Promise(resolve => {
		const dataImport = {}
		snapshot.docs.forEach(doc => {
			const data = doc.data()
			if (!data.isDeleted) {
				const itemReturn = formatMenuItems(data, restaurantId)

				if (itemReturn.thumbnailUri === '' && itemReturn.imageUri !== '') {
					itemReturn.thumbnailUri = itemReturn.imageUri
				}

				const updateCategory = categoryIndex => {
					if (categoryIndex !== -1 && restaurantId) {
						const category = updatedMenuItemCategories.menuItemCategories[categoryIndex]
						const updatedCategory = {
							...category,
							items: [...category.items],
							restaurantIds: [...category.restaurantIds],
							image: category.image,
						}

						updatedCategory.items.push({
							id: itemReturn.id,
							desc: itemReturn.description,
							category: category.name,
							name: itemReturn.name,
							menuId: '',
							promoPrice: itemReturn.promo,
							rId: itemReturn.restaurantId,
							image: itemReturn.imageUri,
							thumbnail: itemReturn.thumbnailUri,
							snoozeUntil: itemReturn.snoozeUntil,
							isSnoozed: itemReturn.isSnoozed,
							ordinal: itemReturn.ordinal,
							hours: itemReturn.hours,
							slug: itemReturn.slug,
							price:
								itemReturn.price === -1
									? '$0.00'
									: Formatter.currencyFormat(itemReturn.price / 100),
						})

						if (!updatedCategory.restaurantIds.includes(data.restaurantId)) {
							updatedCategory.restaurantIds.push(data.restaurantId)
						}

						if (
							!updatedCategory.image ||
							updatedCategory.image.url === '' ||
							!updatedCategory.image.url
						) {
							updatedCategory.image = {
								url: itemReturn.imageUri,
								thumbnailUrl: itemReturn.thumbnailUri,
							}
						}
						updatedMenuItemCategories.menuItemCategories[categoryIndex] = updatedCategory
					}
				}

				if (!checkSnooze(itemReturn.isSnoozed, itemReturn.snoozeUntil)) {
					// First try to use menuItemCategoryIds if they exist
					if (data.menuItemCategoryIds && data.menuItemCategoryIds.length > 0) {
						data.menuItemCategoryIds.forEach((catId: string) => {
							const categoryIndex = updatedMenuItemCategories.menuItemCategories.findIndex(
								cat => cat.id === catId
							)
							updateCategory(categoryIndex)
						})
					}
					// If no menuItemCategoryIds, try to match with posCategory
					else if (itemReturn.posCategory) {
						updatedMenuItemCategories.menuItemCategories.forEach((category, index) => {
							if (
								category.linkedCategories &&
								category.linkedCategories
									.map(category => category.toLowerCase())
									.includes(itemReturn.posCategory.toLowerCase())
							) {
								updateCategory(index)
							}
						})
					}
				}

				dataImport[data.id] = itemReturn
			}
		})

		updatedMenuItemCategories.menuItemCategories.forEach(category => {
			if (category.items !== null) category.items.sort((a, b) => a.ordinal - b.ordinal)
		})
		dataImport['menuItemCategories'] = updatedMenuItemCategories.menuItemCategories
		resolve(dataImport)
	})
}
